<div class="form-group">
    <label for="strength{{index}}" class="control-label">Strength {{index + 1}}</label>
    <select class="form-control" name="strength{{index}}" id="strength{{index}}" [(ngModel)]="strength" (ngModelChange)="onStrengthChanged($event)">
        <option value="{{currentStrength}}" *ngFor="let currentStrength of strengths()">{{currentStrength}}</option>
    </select>
</div>